/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var objectValues = Object.values || function (obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};

export default objectValues;



//////////////////
// WEBPACK FOOTER
// ./~/graphql/polyfills/objectValues.mjs
// module id = oAYn
// module chunks = 9